import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetActividadesPendientes, IGetActividadSolicitudInfo, IGetSolicitudActividades, IGetMisPqrsd, SeguimientoDTO } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';
import { IGetUsuariosValidos } from '../../../shared/interfaces/database/tramite';
import { Page } from '../../../shared/interfaces/pageable';
import { TableLazyLoadEvent } from 'primeng/table';
import { Utils } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SolicitudActividadesService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/solicitud-actividades`;

  constructor(private readonly http: HttpClient) {}

  getActividadesPendientesForUser(): Observable<IGetActividadesPendientes[]> {
    return this.http.get<IGetActividadesPendientes[]>(`${this.apiUrl}/actividades-pendientes`);
  }

  getActividadSolicitudInfo(solicitudActividadId: number): Observable<IGetActividadSolicitudInfo> {
    return this.http.get<IGetActividadSolicitudInfo>(`${this.apiUrl}/info/solicitud/${solicitudActividadId}`);
  }

  getSolicitudActividades(solicitudId: number): Observable<IGetSolicitudActividades[]> {
    return this.http.get<IGetSolicitudActividades[]>(`${this.apiUrl}/solicitud/${solicitudId}`);
  }

  finalizarActividad(solicitudActividadId: number, request?: SeguimientoDTO, documentos?: File[]): Observable<number> {
    const formData: FormData = new FormData();    
    if (request) {
      if (documentos) {
        documentos.forEach((file, index) => {
          formData.append('documentos', file);
        });
      }
      formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    }
    return this.http.put<number>(`${this.apiUrl}/finalizar/${solicitudActividadId}`, formData);
  }

  getUsuariosValidosParaActividad(tramActividadId: number): Observable<IGetUsuariosValidos[]> {
    return this.http.get<IGetUsuariosValidos[]>(`${this.apiUrl}/usuarios-validos/${tramActividadId}`);
  }

  reasignarActividad(solicitudActividadId: number, usuarioId: number): Observable<string> {
    return this.http.put(`${this.apiUrl}/reasignar/${solicitudActividadId}/${usuarioId}`, null, { responseType: 'text' });
  }

  reabrirActividad(solicitudActividadId: number): Observable<string> {
    return this.http.post(`${this.apiUrl}/reabrir/${solicitudActividadId}`, null, { responseType: 'text' });
  }

  getMisPqrsd(tramEstados: string[], tramActividadEstados: string[]): Observable<IGetMisPqrsd[]> {
    return this.http.get<IGetMisPqrsd[]>(`${this.apiUrl}/mis-pqrsd/${tramEstados.join(',')}/${tramActividadEstados.join(',')}`);
  }

  getAllMisPqrsd(tramEstados: string[] = ['ACTIVO'], tramActividadEstados: string[] = ['PENDIENTE'], event?: TableLazyLoadEvent): Observable<Page<IGetMisPqrsd>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<IGetMisPqrsd>>(`${this.apiUrl}/mis-pqrsd/all/${tramEstados.join(',')}/${tramActividadEstados.join(',')}`, { params });
  }

  asignacionManualUsuario(solicitudActividadId: number, usuarioId: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiUrl}/asignacion-manual/${solicitudActividadId}/${usuarioId}`, null);
  }
}
